import { FC, useEffect, useState } from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kStyleConst } from "src/kStyle";
import ShimmerView from "./ShimmerView";

const FormEntry: FC<{
  myTitle: string;
  value: string;
  onChangeText: (text: string) => void;
}> = ({ myTitle, value, onChangeText }) => {
  const [sIsLoaded, _setIsLoaded] = useState<boolean>(false);
  useEffect(() => {
    setTimeout(() => _setIsLoaded(true), 300);
  }, []);
  return (
    <View style={styles.P09_Column}>
      <Text style={styles.P09_FormTitle}>{myTitle}</Text>
      <ShimmerView loading={!sIsLoaded} style={styles.inputShimmer}>
        <TextInput value={value} onChangeText={onChangeText} style={styles.gFormInput} />
      </ShimmerView>
    </View>
  );
};

export default FormEntry;

const styles = StyleSheet.create({
  P09_Column: {
    flexDirection: "column",
    flex: 1,
    flexWrap: "wrap",
    minWidth: kStyleConst.kMinWidth,
  },
  P09_FormTitle: {
    ...kFonts.formLegend,
  },
  gFormInput: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    borderRadius: 2,
    flex: 1,
    height: 36,
    marginTop: 5,
    outlineColor: kColors.transparent,
    paddingLeft: kStyleConst.kSpacing,
    paddingRight: 40,
    paddingVertical: 10,
  },
  inputShimmer: {
    height: kStyleConst.kSimmerHeight,
    width: "100%",
  },
});
